import React from 'react';
import Icon from '../icon/Icon';

class Avatar extends React.Component {
  render() {
    const { name, icon } = this.props;
    return (
      <div className="avatar">
        {icon && <Icon icon={icon} />}
        {!icon && name.charAt(0)}
      </div>
    );
  }
}

export default Avatar;
